<template>
  <div class="video_wrap">
    <IframeVideo :url="videoURL" />
    <div class="bottom">
      <div class="contrl" id="contrl">
        <div class="left">
          <div class="circular circular1">
            <div class="circular circular2">
              <!-- 圆点 -->
              <div class="circular circular3"></div>
              <!-- 四个角 -->
              <a href="#" class="horn horn-top" @click="handleCtrlClick(0)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a href="#" class="horn horn-right" @click="handleCtrlClick(3)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a href="#" class="horn horn-bottom" @click="handleCtrlClick(1)">
                <i class="iconfont icon-xiangxia" />
              </a>
              <a href="#" class="horn horn-left" @click="handleCtrlClick(2)">
                <i class="iconfont icon-xiangxia" />
              </a>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="r_top">
            <div class="box">
              <!-- <div class="label">截图</div> -->
            </div>
          </div>
          <div class="r_bottom">
            <div class="box" @click="putPoint">
              <div class="label">位置存储</div>
            </div>
          </div>
        </div>
      </div>
      <div class="position">
        <div class="title">位置选择</div>
        <div class="nums">
          <div :class="['item' ,  activePresetPoint === nums  && 'active' ]" v-for="(nums) in preset" :key="nums" @click="postPoint(nums)">{{ nums }}</div>
        </div>
      </div>
      <div class="img-group" v-show="false">
        <div class="title">
          <div>图片显示</div>
          <div>显示全部</div>
        </div>
        <div v-for="(item, index) in imgList" :key="index">
          <div class="pic">
            <div v-if="pic" class="pic_item" v-for="(pic, _index) in item.picList" :key="_index">
              <ImageProxy :url="pic.thumbUrl" :index="index" :_index="_index" :click="handleClickImg" />
              <div class="time">{{ pic.cdate }}</div>
            </div>
            <div v-else class="pic_item"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import IframeVideo from "./../components/iframe.vue";
import moment from "moment";
import ScreenShot from "@/utils/screenShot"

export default {
  components: {
    IframeVideo,
  },

  props: {
    videoInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      videoURL: "",
      channelNo: "",
      ysNo: "",
      imgList: [],
      no: localStorage.getItem("no"),
      preset: [], // 预设点
      activePresetPoint: null // 高亮的预设点 下标
    };
  },

  async created () {
    this.$toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
    })
    // 获取视频流地址
    await this.getThirdCamera()
    // 拿到视频信息后获取预设点
    this.getPoint()

    this.$toast.clear()
  },

  methods: {
    // 获取第三方摄像头
    async getThirdCamera (no = this.no) {
      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });

      await this.$api
        .getThirdCamera({ gatewayNo: no })
        .then(res => {
          try {
            this.$toast.clear();
            let token = res.accessToken;

            if (!this.$isblank(res.videos)) {
              const videos = res.videos.map(item => {
                return {
                  ...item,
                  videoHdUrl: `https://open.ys7.com/ezopen/h5/iframe?url=${item.videoHdUrl}&accessToken=${token}`
                };
              });

              return this.renderVideo(videos[0])
            } else {
            }
          } catch (err) {
            console.error("err222:", err);
          }
        })
        .catch(err => {
          this.$refs.pageToast && (this.$refs.pageToast.type = 1);
          this.$toast.clear();
        });
    },

    async renderVideo (data) {
      try {
        let { videoHdUrl, channelNo, ysNo } = data
        this.videoURL = videoHdUrl;
        this.channelNo = channelNo;
        this.ysNo = ysNo;
      } catch (e) {
        console.error("e:", e);
      }
    },

    // 视频控制
    async handleCtrlClick (index) {
      if (typeof index !== "number") return;
      await this.$api
        .ctrlCamera({
          ysNo: this.ysNo,
          channelNo: Number(this.channelNo),
          direction: String(index),
        })
        .then((res) => {
          if (res.errcode === 0) {
          } else {
            this.$toast.fail(res.errmsg);
          }
        });
    },


    // 获取预置点
    async getPoint () {
      await this.$api.rootMonitor_getPoint({
        ysNo: this.ysNo,
        channelNo: this.channelNo
      }).then(res => {

        const { errcode, preset } = res
        if (errcode === 0) {
          this.preset = preset ? JSON.parse(preset) : []
        }
      })
    },

    // 新增预置点
    async putPoint () {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      })
      await this.$api.rootMonitor_putPoint({
        ysNo: this.ysNo,
        channelNo: this.channelNo,
      }).then(res => {
        const { errcode, index } = res
        if (errcode === 0) {
          this.$toast(res.errmsg)
          this.preset.push(index)
        } else {
          this.$toast(`新增预置点异常:${res.errmsg}`)
        }
      })

      this.$toast.clear()
    },

    // 点击调用预置点
    async postPoint (pointIndex) {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      })
      await this.$api.rootMonitor_postPoint({
        ysNo: this.ysNo,
        channelNo: this.channelNo,
        index: pointIndex
      }).then(res => {
        const { errcode, } = res
        if (errcode === 0) {
          this.activePresetPoint = pointIndex
        } else {
          this.$toast(`调用预置点异常:${res.errmsg}`)
        }
      })

      this.$toast.clear()
    },

    // 清除预置点
    async deletePoint () {
      await this.$api.rootMonitor_deletePoint()
    }
  },
};
</script>

<style lang="scss" scoped>
.video_wrap {
  background: #ffffff;

  .video {
    width: 100%;
    height: 220px;
    background: #999;
  }

  .body {
    padding: 12px 10px;
  }

  .contrl {
    display: flex;
    margin-bottom: 22px;
    padding: 12px;
    width: 100%;
    box-sizing: border-box;

    .left {
      position: relative;
      flex: 1;
      width: 50%;

      .circular {
        border-radius: 50%;
      }

      .circular1 {
        position: relative;
        width: 183.54px;
        height: 183.54px;
        background: rgba(241, 246, 251, 1);
        box-shadow: 2px 2px 8px 0px rgba(37, 87, 210, 0.15);
        text-align: center;
      }

      .circular2 {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 144px;
        height: 144px;
        background: linear-gradient(
            129.67deg,
            rgba(122, 127, 133, 0.4) 0%,
            rgba(255, 255, 255, 0.4) 100%
          ),
          linear-gradient(
            133.76deg,
            rgba(230, 231, 237, 1) 0%,
            rgba(247, 248, 250, 1) 100%
          );
        background-blend-mode: soft-light;
        box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
          -2px -3px 8px 0px rgba(250, 250, 252, 1),
          1px 1px 5px 0px rgba(177, 181, 198, 1);
      }

      .circular3 {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 20.17px;
        height: 20.17px;
        background: rgba(37, 87, 210, 1);
      }

      .horn {
        position: absolute;

        i {
          color: rgba(206, 213, 220, 1);
          font-size: 22px;
        }
      }

      .horn-top {
        top: 0px;
        left: 60px;
        transform: rotateX(145deg);
      }

      .horn-right {
        top: 52px;
        right: 6px;
        transform: rotate(-90deg);
      }

      .horn-bottom {
        bottom: 0px;
        left: 63px;
      }

      .horn-left {
        top: 52px;
        left: 6px;
        transform: rotate(90deg);
      }
    }

    .right {
      flex: 1;
      padding: 16px 10px 0 30px;
      font-size: 14px;
      width: 50%;
      box-sizing: border-box;

      .box {
        text-align: center;

        .label {
          margin-top: 8px;
        }

        i {
          color: rgba(46, 95, 215, 1);
        }
      }

      .r_top,
      .r_bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // width: 50%;
        box-sizing: border-box;

        .r_block {
          position: relative;
          display: inline-block;
          width: 44.13px;
          height: 44.13px;
          line-height: 44.13px;
          text-align: center;
          background: linear-gradient(
              129.67deg,
              rgba(122, 127, 133, 0.4) 0%,
              rgba(255, 255, 255, 0.4) 100%
            ),
            linear-gradient(
              133.76deg,
              rgba(230, 231, 237, 1) 0%,
              rgba(247, 248, 250, 1) 100%
            );
          background-blend-mode: soft-light;
          box-shadow: inset 1px 1px 3px 0px rgba(235, 236, 240, 1),
            -2px -3px 4px 0px rgba(250, 250, 252, 1),
            1px 1px 2px 0px rgba(177, 181, 198, 1);
          border-radius: 10px;
        }

        .miaozhun {
          position: absolute;
          top: 1px;
          left: 2px;
          right: 0;
          bottom: 0;
          margin: 0;
          font-size: 20px;
        }

        img {
          width: 60%;
          height: 60%;
        }

        .label {
          // border: 1px solid #999;
          border-radius: 20px;
          padding: 10px 14px;
          box-shadow: 1px 2px 2px 1px #999;
        }
      }

      .r_top {
        margin-bottom: 20px;
      }
    }
  }

  .img-group {
    padding: 0 10px 10px;

    .title {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .date {
      line-height: 40px;
      text-align: left;
    }

    .time {
      font-size: 12px;
      text-align: left;
    }

    .pic {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      width: 100%;

      .pic_item {
        width: 33%;
        // height: 100px;
        margin-bottom: 0.3rem;
        overflow: hidden;
        margin-right: 11px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.position {
  .title {
    font-size: 14px;
  }

  .nums {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 10px;

    .item {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #f7f7f7;
      border: 0.946083px solid #eceef2;
      border-radius: 50%;
      color: #464646;
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }

    .active {
      background: #3a6ae0;
      color: #ffffff;
    }
  }
}
</style>
